export default __webpack_public_path__ + "static/jira-service-management_attribution_dark-d2d1f1ccda18a83b3e360ff9a8c95f83.svg";